import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5a0c3a6e")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CloseModal = _resolveComponent("CloseModal")

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    ($props.modelValue)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: ["sys-modal", !$props.noScrollBody ? 'scroll-body' : ''],
          ref: "dialog-body",
          tabindex: "0",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onclickOutside($event)))
        }, [
          _renderSlot(_ctx.$slots, "header", {}, undefined, true),
          _createVNode("div", {
            class: [$props.classes, "sys-modal__body"],
            ref: "dialogContent",
            style: { width: $props.width }
          }, [
            _createVNode(_component_CloseModal, {
              class: "close-modal",
              onClick: $setup.closeModal
            }, null, 8, ["onClick"]),
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ], 6)
        ], 2))
      : _createCommentVNode("", true)
  ]))
})